import axios from 'src/api/axios.config'

// https://api.joedar.com/personal/frontstage/diary/detail.by.eventTime.keywords?eventTime=1684560600
export const test = (callback) => {
  const url = '/frontstage/diary/detail.by.eventTime?eventTime=1684056780'
  axios.post(url).then(resp => {
    callback(resp)
  }).catch(err => {
    console.log('err is ', err)
  })
}

export const getIndexTop30 = (callback) => {
  const url = '/frontstage/index.top30'
  axios.get(url).then(resp => {
    callback(resp.data)
  }).catch(err => {
    console.log('err is ', err)
  })
}

export const testGet = (callback) => {
  const url = `/backstage/admin/test.get`
  axios.get(url).then(resp => {
    console.log('backstage/admin/test.get resp ', resp)
    callback(resp.data)
  }).catch(err => {
    callback(err)
    // console.log('err is ', err)
  })
}

